var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars2Mobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 612,
    viewBox: "0 0 183 612",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_37890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.4018 393.324L49.3303 396.826L45.0743 416.975L40.8182 396.826L21.6929 393.27L40.7105 388.637L45.0743 369.619L49.3843 388.637L68.4018 393.324Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4422 163.661L45.7751 165.654L43.3508 176.86L40.9803 165.654L30.3132 163.661L40.9264 161.075L43.3508 150.408L45.7751 161.075L56.4422 163.661Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.375 607.743C100.855 607.825 100.382 608.089 100.04 608.489C99.6978 608.89 99.51 609.398 99.51 609.925C99.51 610.451 99.6978 610.96 100.04 611.36C100.382 611.76 100.855 612.025 101.375 612.107C101.895 612.025 102.368 611.76 102.71 611.36C103.052 610.96 103.24 610.451 103.24 609.925C103.24 609.398 103.052 608.89 102.71 608.489C102.368 608.089 101.895 607.825 101.375 607.743Z",
    fill: "#FFC727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.388 587.596C127.816 587.596 126.309 588.22 125.197 589.332C124.086 590.443 123.462 591.95 123.462 593.522C123.462 595.094 124.086 596.601 125.197 597.712C126.309 598.824 127.816 599.448 129.388 599.448C130.959 599.448 132.467 598.824 133.578 597.712C134.69 596.601 135.314 595.094 135.314 593.522C135.314 591.95 134.69 590.443 133.578 589.332C132.467 588.22 130.959 587.596 129.388 587.596Z",
    fill: "#FFC727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_37890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263,
    height: 610.792,
    fill: "white",
    transform: "translate(-80 0.662537)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars2Mobile);
export default __webpack_public_path__ + "static/media/stars2-mobile.92583c5c60c4197701110b4b9a96656f.svg";
export { ForwardRef as ReactComponent };